import React, { useRef, useEffect, useState } from "react";
import ModalDefault from "../../modalDefault";

import { DataTable } from "mantine-datatable";
import { toast } from "react-hot-toast";
import {
  ApiGetAllPeriodos,
  ApiActivarDesactivarPeriodo,
  ApiDeletePeriodo,
} from "../../../api/periodos.js";
import { ActionIcon, Group, MultiSelect, Switch } from "@mantine/core";

const BATCH_SIZE = 12;
const TablaOpciones = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [allPeriodos, setAllPeriodos] = useState([]); // Estado para todas los periodos
  const [filteredPeriodos, setFilteredPeriodos] = useState([]); // Estado para periodos filtradas
  const [fetching, setfetching] = useState(true);
  const [selectedPeriodo, setSelectedPeriodo] = useState(null);
  const [selectedPeriodoNombres, setSelectedPeriodoNombres] = useState([]);

  // Estados para scroll infinito y filtros
  const [loadingMore, setLoadingMore] = useState(false);
  const [loadedRecords, setLoadedRecords] = useState(BATCH_SIZE);
  const [queryNombrePeriodo, setQueryNombrePeriodo] = useState("");
  const [queryFechaInicio, setQueryFechaInicio] = useState("");
  const [queryFechaFin, setQueryFechaFin] = useState("");
  const scrollViewportRef = useRef(null);

  const columns = [
    {
      accessor: "nombre",
      title: "Periodo",
      textAlignment: "center",
      filter: (
        <MultiSelect
          data={filteredPeriodos.map((periodo) => periodo.nombre)}
          value={selectedPeriodoNombres}
          onChange={setSelectedPeriodoNombres}
          placeholder="Filtrar por periodo..."
        />
      ),
      filtering: selectedPeriodoNombres.length > 0,
    },
    {
      accessor: "fecha_inicio",
      title: "Fecha de Inicio ",
      textAlignment: "center",

    },
    {
      accessor: "fecha_fin",
      title: "Fecha de fin",
      textAlignment: "center",
    },
    {
      accessor: "activo",
      title: "Estado",
      textAlignment: "center",
      render: (record) => toogle(record),
    },
    {
      accessor: "acciones",
      title: "Acciones",
      textAlignment: "center",
      render: (record) => opciones(record),
    },
  ];

  useEffect(() => {
    init();
  }, [props.updateList]);

  const init = async () => {
    setfetching(true);
    const { data } = await ApiGetAllPeriodos();
    const filterPeriodos = data.filter((periodo) => periodo.estado === true); 
    setAllPeriodos(filterPeriodos);
    setFilteredPeriodos(filterPeriodos);
    setfetching(false);
  };

  // Logica para filtros
  useEffect(() => {
    const selectedPeriodoNombreSet = new Set(selectedPeriodoNombres);
    const isPeriodoNombreSelected = (periodo) =>
      selectedPeriodoNombreSet.size === 0 ||
      selectedPeriodoNombreSet.has(periodo.nombre);
      
    const filtered = allPeriodos.filter(
      (periodo) =>
        periodo.nombre.toLowerCase().includes(queryNombrePeriodo.toLowerCase()) &&
        periodo.fecha_inicio.toLowerCase().includes(queryFechaInicio.toLowerCase()) &&
        periodo.fecha_fin.toLowerCase().includes(queryFechaFin.toLowerCase()) &&
        isPeriodoNombreSelected(periodo)        
    );
    setFilteredPeriodos(filtered);
  }, [allPeriodos, queryNombrePeriodo, queryFechaInicio, queryFechaFin, selectedPeriodoNombres]);

  // Carga más datos cuando se llega al final del scroll
  const loadMoreData = () => {
    if (loadedRecords < filteredPeriodos.length) {
      setLoadingMore(true);
      setTimeout(() => {
        setLoadedRecords(loadedRecords + BATCH_SIZE);
        setLoadingMore(false);
      }, 1000);
    }
  };

  // Asegúrate de no cargar más registros de los disponibles
  const visiblePeriodos = filteredPeriodos.slice(
    0,
    Math.min(loadedRecords, filteredPeriodos.length)
  );

  const editPeriodo = (row) => {
    const { pre_periodo_id, nombre, fecha_inicio, fecha_fin} = row;
    props.setType("editar");
    props.setState({
      ...props.state,
      pre_periodo_id,
      nombre,
      fecha_inicio,
      fecha_fin,
    });
  };

  const onShowModal = (e) => {
    setShowModal(true);
    setSelectedPeriodo(e);
  };

  const onClosedModal = () => {
    setShowModal(false);
    setSelectedPeriodo(null);
  };

  const onDelete = async () => {
    const { estado, pre_periodo_id } = selectedPeriodo;
    const { sms, mensaje } = await ApiDeletePeriodo({
      pre_periodo_id,
      pre_estado: !estado,
    });
    if (sms === "ok") {
      toast.success(mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid green",
          padding: "16px",
          color: "white",
          background: "green",
          borderColor: "white",
        },
        iconTheme: {
          primary: "green",
          secondary: "white",
        },
      });
      setSelectedPeriodo(null);
      props.updateListFn();
    } else {
      toast.error(mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
    }
    onClosedModal();
  };

  // create a toogle to change the status of the period
  const toogleStatus = async (row) => {
    const { pre_periodo_id, activo } = row;
    const { sms, mensaje } = await ApiActivarDesactivarPeriodo({
      pre_periodo_id,
      activo: !activo
    });
    if (sms === "ok") {
      toast.success(mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid green",
          padding: "16px",
          color: "white",
          background: "green",
          borderColor: "white",
        },
        iconTheme: {
          primary: "green",
          secondary: "white",
        },
      });
      props.updateListFn();
    } else {
      toast.error(mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
    }
  };

  // how to integrate the toogle status in the table
  const toogle = (row) => {
    return (

      // use a switch to change the status of the period and center
      <Group position="center">
        <Switch
          checked={row.activo}
          onChange={() => toogleStatus(row)}
          color="blue"
        />
      </Group>
    );
  };

  const opciones = (row) => {
    return (
      <Group spacing={4} position="center" noWrap>
        <ActionIcon
          color="blue"
          onClick={() => {
            editPeriodo(row);
          }}
        >
          <i className="fas fa-file-pen"></i>
        </ActionIcon>
        <ActionIcon
          color="red"
          onClick={() => {
            onShowModal(row);
          }}
        >
          <i className="fas fa-trash"></i>
        </ActionIcon>
        <ModalDefault
          bandera={"confirmacion"}
          modal={showModal}
          size={"sm"}
          icontitulo={<null />}
          titulo={`Confirmación`}
          closeAction={onClosedModal}
        >
          <div className="row py-4 justify-content-center text-align-center ">
            Realmente desea eliminar el periodo y sus dias inactivos
          </div>
          <div className="d-flex justify-content-end flex-row align-self-start my-4">
            <button
              type=""
              onClick={onClosedModal}
              className="bg-btn-vet-danger sombra mx-1"
            >
              Cancelar
            </button>
            <button
              type=""
              onClick={onDelete}
              className="bg-btn-vet sombra mx-1"
            >
              <i className="fas fa-save"> Eliminar</i>
            </button>
          </div>
        </ModalDefault>
      </Group>
    );
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <DataTable
          borderRadius="md"
          className="bordecompleto bgfondo "
          highlightOnHover
          noRecordsText="No se encontraron datos"
          columns={columns}
          totalRecords={allPeriodos.length}
          withColumnBorders
          records={visiblePeriodos}
          fetching={fetching || loadingMore}
          onScrollToBottom={loadMoreData}
          scrollViewportRef={scrollViewportRef}
          style={{ maxHeight: "430px", overflowY: "auto" }}
        />
      </div>
    </div>
  );
};

export default TablaOpciones;